import { useEffect, useRef, useState } from 'react';
import { api } from '../api.js';

// Free-text input with autocomplete suggestions fetched from /api/autocomplete/<endpoint>.
// Renders an <input> with a dropdown of matching distinct values from the DB.
export default function AutocompleteInput({
  value, onChange, endpoint, placeholder, required, className,
}) {
  const [open, setOpen] = useState(false);
  const [items, setItems] = useState([]);
  const containerRef = useRef(null);

  useEffect(() => {
    let active = true;
    const t = setTimeout(async () => {
      try {
        const qs = value ? `?q=${encodeURIComponent(value)}` : '';
        const res = await api.get(`/api/autocomplete/${endpoint}${qs}`);
        if (active) setItems(res.data.values || []);
      } catch { /* ignore */ }
    }, 150);
    return () => { active = false; clearTimeout(t); };
  }, [value, endpoint]);

  useEffect(() => {
    const onDoc = (e) => {
      if (!containerRef.current?.contains(e.target)) setOpen(false);
    };
    document.addEventListener('mousedown', onDoc);
    return () => document.removeEventListener('mousedown', onDoc);
  }, []);

  return (
    <div ref={containerRef} className="relative">
      <input
        type="text"
        value={value || ''}
        onChange={(e) => { onChange(e.target.value); setOpen(true); }}
        onFocus={() => setOpen(true)}
        placeholder={placeholder}
        required={required}
        className={className || 'input'}
        autoComplete="off"
      />
      {open && items.length > 0 && (
        <ul className="absolute z-10 mt-1 max-h-48 w-full overflow-auto rounded-md border border-zinc-800 bg-zinc-900 shadow-lg">
          {items.map((v) => (
            <li
              key={v}
              onClick={() => { onChange(v); setOpen(false); }}
              className="cursor-pointer px-3 py-1.5 text-sm hover:bg-zinc-800"
            >
              {v}
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}
